export function ArrowIcon({ className = 'w-12 ml-4' }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 45 12">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M1 6h42M38.643 1l4.91 5-4.91 5"></path>
    </svg>
  );
}

export function DownIcon({ className = 'w-4' }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 5">
      <path
        fill="currentColor"
        d="M6 3.032C3.866 3.032 2.008 1.776 1.445 0H0c.596 2.475 3.102 4.262 6 4.262S11.404 2.475 12 0h-1.445C9.992 1.776 8.135 3.032 6 3.032z"></path>
    </svg>
  );
}

export function HamburgerIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 18">
      <path
        fill="currentColor"
        d="M.5 18h27v-3H.5v3zm0-7.5h27v-3H.5v3zM.5 0v3h27V0H.5z"></path>
    </svg>
  );
}

export function CloseIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M20 2.014L17.986 0 10 7.986 2.014 0 0 2.014 7.986 10 0 17.986 2.014 20 10 12.014 17.986 20 20 17.986 12.014 10 20 2.014z"></path>
    </svg>
  );
}

export function Logo({
  className,
  classNameImage,
  classNameText,
}: {
  className?: string;
  classNameImage?: string;
  classNameText?: string;
}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 188 39">
      <g clipPath="url(#clip0_80_126)">
        <g className={classNameImage}>
          <path
            fill="#59BAC9"
            d="M7.168 18.595v-2.55c1.222 0 2.28-.988 2.28-2.305 0-1.234-.977-2.303-2.28-2.303V8.886c2.607 0 4.806 2.14 4.806 4.855 0 2.632-2.118 4.854-4.806 4.854z"></path>
          <path
            fill="#59BAC9"
            d="M0 39h38.61V0H0v39zM2.851 2.88h32.99v33.322H2.85V2.88z"></path>
          <path
            fill="#59BAC9"
            d="M31.36 27.563h-5.376v2.55h5.376v-2.55zM25.985 19.418c-2.607 0-4.806 2.139-4.806 4.854 0 1.234-.978 2.304-2.281 2.304a2.288 2.288 0 01-2.28-2.304c0-2.633-2.119-4.854-4.807-4.854-2.606 0-4.806 2.139-4.806 4.854v6.007h2.526v-6.007c0-1.234.977-2.304 2.28-2.304 1.222 0 2.281.988 2.281 2.304 0 2.633 2.118 4.855 4.806 4.855s4.806-2.14 4.806-4.855c0-1.234.977-2.304 2.28-2.304 1.304 0 2.281.988 2.281 2.304h2.526c0-2.715-2.118-4.854-4.806-4.854z"></path>
        </g>
        <path
          className={classNameText}
          fill="#114C6B"
          d="M66.794 20.652c0 5.266-3.666 8.31-9.042 8.31h-4.235V12.589h4.235c5.62 0 9.042 2.962 9.042 8.063zm-2.525 0c0-3.95-2.444-5.76-6.517-5.76H55.88v11.766h1.873c3.91 0 6.517-2.139 6.517-6.006zM69.319 13.823c0-.823.651-1.399 1.547-1.399.897 0 1.548.576 1.548 1.399 0 .823-.651 1.399-1.547 1.399-.897 0-1.548-.576-1.548-1.4zm.407 3.62h2.362v11.519h-2.362V17.443zM74.288 27.234l1.384-1.563c1.06 1.07 2.118 1.563 3.503 1.563 1.303 0 2.2-.494 2.2-1.48 0-2.634-6.599-.577-6.599-5.02 0-1.975 1.71-3.538 4.48-3.538 1.955 0 3.34.659 4.399 1.646l-1.222 1.563c-.814-.74-1.792-1.234-3.095-1.234-1.466 0-2.2.576-2.2 1.399 0 2.386 6.599.658 6.599 5.019 0 2.303-2.037 3.62-4.562 3.62-2.362 0-3.747-.823-4.887-1.975zM93.593 28.221c-.896.659-1.874 1.07-3.014 1.07-2.118 0-3.747-1.07-3.747-3.867V19.5h-2.28l.488-2.057h1.792v-3.209h2.362v3.21h4.236V19.5h-4.236v5.924c0 1.152.652 1.728 1.63 1.728.733 0 1.221-.247 1.873-.658l.896 1.727zM102.716 28.962c-.082-.576-.163-1.07-.245-1.645-.733 1.234-2.036 1.892-3.665 1.892-2.362 0-3.992-1.317-3.992-3.538 0-2.222 1.874-3.703 4.97-3.703 1.058 0 1.873.165 2.606.33v-.576c0-1.646-1.059-2.551-2.77-2.551-1.303 0-2.28.411-3.176 1.07l-.896-1.728c1.14-.823 2.525-1.317 4.317-1.317 3.014 0 4.887 1.646 4.887 4.608v3.95c0 1.233.082 2.385.244 3.29h-2.28v-.082zm-.326-4.525v-.494c-.652-.165-1.385-.329-2.281-.329-2.036 0-2.932.823-2.932 1.975 0 .987.814 1.728 2.199 1.728 1.711 0 3.014-1.07 3.014-2.88zM110.291 12.589h-2.362v16.29h2.362V12.59zM131.47 21.968v6.994h-2.362v-6.747c0-1.974-.978-2.962-2.444-2.962-1.548 0-2.851.988-2.851 3.374v6.253h-2.362v-6.665c0-1.974-.978-2.962-2.444-2.962-1.548 0-2.851.988-2.851 3.374v6.253h-2.362V17.36h2.281l.081 1.646c.733-1.234 1.955-1.974 3.584-1.974s2.933.822 3.584 2.386c.815-1.481 2.2-2.386 4.073-2.386 2.362.082 4.073 1.727 4.073 4.936zM133.914 23.203c0-3.785 2.769-6.09 5.946-6.09 3.177 0 5.946 2.222 5.946 6.09 0 3.784-2.769 6.088-5.946 6.088-3.177-.082-5.946-2.304-5.946-6.088zm9.448-.083c0-2.468-1.629-3.95-3.502-3.95-1.874 0-3.584 1.482-3.584 3.95 0 2.469 1.629 3.95 3.502 3.95 1.955.082 3.584-1.4 3.584-3.95zM155.662 28.221c-.896.659-1.873 1.07-3.014 1.07-2.118 0-3.747-1.07-3.747-3.867V19.5h-2.28l.488-2.057h1.792v-3.209h2.363v3.21h4.235V19.5h-4.235v5.924c0 1.152.651 1.728 1.629 1.728.733 0 1.222-.247 1.873-.658l.896 1.727zM157.617 13.823c0-.823.652-1.399 1.548-1.399s1.548.576 1.548 1.399c0 .823-.652 1.399-1.548 1.399s-1.548-.576-1.548-1.4zm.326 3.62h2.362v11.519h-2.362V17.443zM163.075 23.203c0-3.785 2.769-6.09 5.946-6.09 3.177 0 5.946 2.222 5.946 6.09 0 3.784-2.769 6.088-5.946 6.088-3.095-.082-5.946-2.304-5.946-6.088zm9.53-.083c0-2.468-1.629-3.95-3.503-3.95-1.873 0-3.584 1.482-3.584 3.95 0 2.469 1.629 3.95 3.503 3.95 1.873.082 3.584-1.4 3.584-3.95zM188 22.133v6.829h-2.362v-6.5c0-2.14-.978-3.127-2.607-3.127-1.548 0-2.932.988-2.932 3.538v6.089h-2.363V17.443h2.281l.082 1.728c.814-1.399 2.117-2.057 3.828-2.057 2.362 0 4.073 1.645 4.073 5.019z"></path>
      </g>
      <defs>
        <clipPath id="clip0_80_126">
          <path fill="#fff" d="M0 0H188V39H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function SpinIcon({ className = 'w-4' }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512">
      <path
        fill="currentColor"
        d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"></path>
    </svg>
  );
}

export function GlobeIcon({ className = 'w-4' }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 25">
      <path
        fill="currentColor"
        d="M12,22c-5.2,0-9.5-4.3-9.5-9.5S6.8,3,12,3s9.5,4.3,9.5,9.5-4.3,9.5-9.5,9.5ZM11.8,21c.1,0,.3,0,.4,0,.9-1.6,1.6-3.3,2-5h-4.4c.4,1.7,1,3.4,2,5ZM15.2,16c-.3,1.7-.9,3.3-1.8,4.9,2.8-.5,5.2-2.4,6.3-4.9h-4.5ZM4.3,16c1.1,2.5,3.5,4.4,6.3,4.9-.8-1.5-1.4-3.2-1.8-4.9h-4.5ZM15.4,15h4.7c.2-.8.4-1.6.4-2.5s-.1-1.7-.4-2.5h-4.7c.2,1.7.2,3.3,0,5ZM9.6,15h4.7c.2-1.7.2-3.3,0-5h-4.7c-.3,1.7-.3,3.3,0,5ZM3.9,15h4.7c-.2-1.7-.2-3.3,0-5H3.9c-.2.8-.4,1.6-.4,2.5s.1,1.7.4,2.5ZM15.2,9h4.5c-1.1-2.5-3.5-4.4-6.3-4.9.8,1.5,1.4,3.2,1.8,4.9ZM9.8,9h4.4c-.4-1.7-1-3.4-2-5-.1,0-.3,0-.4,0-.9,1.6-1.6,3.3-2,5ZM4.3,9h4.5c.3-1.7.9-3.3,1.8-4.9-2.8.5-5.2,2.4-6.3,4.9Z"
      />
    </svg>
  );
}
